module.exports = __webpack_public_path__ + "img/annotation-noicon.6508f26e.svg";